import { ApiService } from '../../services/api_service';
import DialogWrapper2 from '../../core/dialog/dialog_wrapper_v2';
import { formatNumber } from '../../core/formatter/formatNumber';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as React from 'react';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';

export interface ZusatztoolsZaehlerProps {
    standortSelected: any;
}

export interface ZusatztoolsZaehlerState {
    zaehlerSelected: any;
}

export class ZusatztoolsZaehler extends React.Component<ZusatztoolsZaehlerProps, ZusatztoolsZaehlerState> {

    constructor(props: any) {
        super(props);
        this.state = {
            zaehlerSelected: null
        };
    }

    @lazyInject(ApiService) private apiService: ApiService;

    private zaehlerstand: Array<any> = [];

    render(): JSX.Element {
        const customActions = [
            {
                id: 'zaehlerablesung',
                label: 'Zählerablesung anzeigen',
                key: 'show',
                func: ((row: any) => this.setState({ zaehlerSelected: row })),
                info: 'Zählerablesung anzeigen'
            }
        ];
        const { standortSelected } = this.props;

        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_ZAEHLER}
                    module={IDs.MOD_ETOOL}
                    actions={['add', 'edit', 'delete']}
                    actionsBtnReihenfolg={['zaehlerablesung', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    addLabel={'Zähler erfassen'}
                    formPreset={{ standort: standortSelected ? standortSelected.tid : 0 }}
                    customActions={customActions}
                // customFormConfig={{
                //     standort: {
                //         readonly: true
                //     }
                // }}
                />
                {this.renderZaehlerablesung()}
            </div>
        );
    }

    renderZaehlerablesung(): JSX.Element {
        if (this.state.zaehlerSelected) {
            const zhl = this.state.zaehlerSelected;

            const customFormatter = (key: string, value: any, data: any, row: any) => {
                if (data && row && row.column) {
                    if (row.column.type === 'DOUBLE') {
                        return <div style={{ textAlign: 'right', paddingRight: 5 }}>{formatNumber(value, 2)}</div>;
                    }
                }
                return value;
            };

            const validateField = (key: string, value: any, data: any, onValueChange: (name: string, value: any) => void) => {
                switch (key) {
                    case 'wert':
                        const max = Math.max(...this.zaehlerstand.map((z: any) => z.wert));

                        if (value < max) {
                            return 'Der eingegebene Wert darf nicht kleiner als der zuletzt eingegebene Wert (' + formatNumber(max, 2) + ') sein.';
                        }
                        break;
                }
            };

            const onAfterAction = (action: string, data: any) => {
                if (action === 'loadDataDone') {
                    this.zaehlerstand = data;
                }
            };

            return (
                <div>
                    <DialogWrapper2
                        title='Zählerablesung'
                        onAfterClose={() => this.setState({ zaehlerSelected: undefined })}
                    >
                        <div style={{ minWidth: 600 }}>
                            <WFormsTableWrapper
                                entity={IDs.ENT_ZAEHLERSTAND}
                                module={IDs.MOD_ETOOL}
                                actions={['add', 'edit', 'delete']}
                                customClass={'Custom-ETA'}
                                formLayout={'flowV2'}
                                addLabel={'Zählerstand erfassen'}
                                formPreset={{ zaehler: zhl.tid, ableser: this.apiService.getUsername() }}
                                customFormConfig={{
                                    zaehler: {
                                        readonly: true
                                    }
                                }}
                                preFilterServer={{ zaehler: zhl.tid }}
                                customFormatter={customFormatter}
                                validateField={validateField}
                                onAfterAction={onAfterAction}
                            />
                        </div>
                    </DialogWrapper2>
                </div>
            );
        }
    }
}
